import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BorderSubtractive from './BorderSubtractive';
import ClientProvider from './client';
export default createDemo(import.meta.url, BorderSubtractive, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/borders/demos/subtractive/BorderSubtractive.tsx",
    "fileName": "BorderSubtractive.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\n\nconst commonStyles = {\n  bgcolor: 'background.paper',\n  border: 1,\n  m: 1,\n  borderColor: 'text.primary',\n  width: '5rem',\n  height: '5rem',\n};\n\nexport default function BorderSubtractive() {\n  return (\n    <Box sx={{ display: 'flex', justifyContent: 'center' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Box sx={{ ...commonStyles, border: 0 }} />\n      <Box sx={{ ...commonStyles, borderTop: 0 }} />\n      <Box sx={{ ...commonStyles, borderRight: 0 }} />\n      <Box sx={{ ...commonStyles, borderBottom: 0 }} />\n      <Box sx={{ ...commonStyles, borderLeft: 0 }} />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 22,
        "focusedLines": 5,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\n\nconst commonStyles = {\n  bgcolor: 'background.paper',\n  border: 1,\n  m: 1,\n  borderColor: 'text.primary',\n  width: '5rem',\n  height: '5rem',\n};\n\nexport default function BorderSubtractive() {\n  return (\n    <Box sx={{ display: 'flex', justifyContent: 'center' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Box sx={{ ...commonStyles, border: 0 }} />\n      <Box sx={{ ...commonStyles, borderTop: 0 }} />\n      <Box sx={{ ...commonStyles, borderRight: 0 }} />\n      <Box sx={{ ...commonStyles, borderBottom: 0 }} />\n      <Box sx={{ ...commonStyles, borderLeft: 0 }} />\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-smi di-jv",
                "commonStyles"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "border"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "0"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-smi di-jv",
                "commonStyles"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "borderTop"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "0"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-smi di-jv",
                "commonStyles"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "borderRight"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "0"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-smi di-jv",
                "commonStyles"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "borderBottom"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "0"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-smi di-jv",
                "commonStyles"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "borderLeft"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "0"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 22,
    "focusedLines": 5,
    "collapsible": true,
    "externals": [
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
